import { useQuery } from "@tanstack/react-query";
import { Agent, emptyPage, Page } from "@/model";
import agentRepository from "@/repository/agentRepository";


const getData = async (page: number, size: number, active: boolean, keyword?: string) => {
    const res = await agentRepository.find(page, size, active, keyword);
    return res.data?.data || emptyPage<Agent>();
};

export const usePaginatedAgents = (page: number, size: number, active: boolean, keyword?: string) => {
    return useQuery<Page<Agent>>({
        queryKey: ['page-agents', page, size, active, keyword],
        queryFn: async () => getData(page, size, active, keyword),
        retry: false
    });
};
